import React, { useState, useEffect } from 'react';
import './menu.css';
import { getFilteredMenu } from './menuPermissions';

export const gestionDeAlmacenMenu = [
  // Nivel principal: Cooler
  {
    title: 'Cooler',
    icono: 'Dashboard.svg',
    enlace: '#', // Modificado de null
    activo: 'cámara_fría/cooler',
    permiso: [2000, 2001, 2002, 2003], // Rango original: 2000 a 2003
    hijos: [
      {
        title: 'Vale Cooler',
        icono: 'Dashboard.svg',
        enlace: 'ValeCooler', // Modificado de URL::route('cooler')
        activo: 'cámara_fría/cooler/vale_cooler',
        permiso: [2000],
      },
      {
        title: 'Tiempos Expo',
        icono: 'Dashboard.svg',
        enlace: 'TiemposExpo', // Modificado de URL::route('cooler.armed_times')
        activo: 'cámara_fría/cooler/tiempos_expo',
        permiso: [2001],
      },
      {
        title: 'Tiempos Impo',
        icono: 'Dashboard.svg',
        enlace: 'TiemposImpo', // Modificado de URL::route('cooler.platform_times')
        activo: 'cámara_fría/cooler/tiempos_impo',
        permiso: [2002],
      },
      {
        title: 'Carga de insumo',
        icono: 'Dashboard.svg',
        enlace: 'CargaInsumos', // Modificado de URL::route('cooler.upload_file')
        activo: 'cámara_fría/cooler/carga_de_insumo',
        permiso: [2003],
      },
    ],
  },

  // Nivel principal: Incidencias
  {
    title: 'Incidencias',
    icono: 'Dashboard.svg',
    enlace: '#', // Modificado de URL::route('incidents')
    activo: 'cámara_fría/incidencias',
    permiso: [2004],
    hijos: [],
  },

  // Nivel principal: Kárdex
  {
    title: 'Kárdex',
    icono: 'Dashboard.svg',
    enlace: '#', // Modificado de URL::route('reports.kardex')
    activo: 'cámara_fría/kárdex',
    permiso: [2005],
    hijos: [],
  },

  // Nivel principal: Reportes Cooler
  {
    title: 'Reportes Cooler',
    icono: 'Dashboard.svg',
    enlace: '#', // Modificado de null
    activo: 'cámara_fría/reportes_cooler',
    permiso: [2006, 2007, 2008, 2009, 2010, 2011], // Rango original: 2006 a 2011
    hijos: [
      {
        title: 'Inventario Cooler',
        icono: 'Dashboard.svg',
        enlace: '#', // Modificado de URL::route('reports.cooler_storage')
        activo: 'cámara_fría/reportes_cooler/inventario_cooler',
        permiso: [2006],
      },
      {
        title: 'Bitácora de cooler',
        icono: 'Dashboard.svg',
        enlace: '#', // Modificado de URL::route('reports.cooler_log')
        activo: 'cámara_fría/reportes_cooler/bitácora_de_cooler',
        permiso: [2007],
      },
      {
        title: 'Bitácora de cooler guía',
        icono: 'Dashboard.svg',
        enlace: '#', // Modificado de URL::route('reports.cooler_log_master')
        activo: 'cámara_fría/reportes_cooler/bitácora_de_cooler_guía',
        permiso: [2008],
      },
      {
        title: 'Trazabilidad Temp. Impo',
        icono: 'Dashboard.svg',
        enlace: 'TransPharmaImpo', // Modificado de URL::route('reports.trans_pharma_impo')
        activo: 'cámara_fría/reportes_cooler/trazabilidad_temp_impo',
        permiso: [2009],
      },
      {
        title: 'Trazabilidad Temp. Expo',
        icono: 'Dashboard.svg',
        enlace: 'TransPharmaExpo', // Modificado de URL::route('reports.trans_pharma_expo')
        activo: 'cámara_fría/reportes_cooler/trazabilidad_temp_expo',
        permiso: [2010],
      },
      {
        title: 'Cooler Trazabilidad',
        icono: 'Dashboard.svg',
        enlace: '#', // Modificado de URL::route('reports.cooler_trasbility')
        activo: 'cámara_fría/reportes_cooler/cooler_trazabilidad',
        permiso: [2011],
      },
    ],
  },

  // Nivel principal: Dashboard Cooler
  {
    title: 'Dashboard Cooler',
    icono: 'Dashboard.svg',
    enlace: 'DashboardCooler', // Modificado de URL::route('cooler.dashboard')
    activo: 'cámara_fría/dashboard_cooler',
    permiso: [2012],
    hijos: [],
  },
];

export const getGestionDeAlmacenMenu = () =>
  getFilteredMenu(gestionDeAlmacenMenu);

const MenuItem = ({ item, activePath, onSetActive, onHoverChange, hoveredItem, onComponentChange }) => {
    
    const [isOpen, setIsOpen] = useState(false); 
    const hasChildren = item.hijos && item.hijos.length > 0;
    
    // Defensa: Asegura que activePath sea un string para evitar el error "undefined.startsWith"
    const currentPath = activePath || ''; 
    
    // Lógica para determinar el resaltado
    const isCurrentActive = item.activo === currentPath;
    const isAncestorActive = currentPath.startsWith(item.activo + '/') && !isCurrentActive;

    // Colapso automático/apertura si es parte del path activo
    useEffect(() => {
        if (isAncestorActive || isCurrentActive) {
            setIsOpen(true);
        }
    }, [isAncestorActive, isCurrentActive]);
    
    // Lógica de Hover (se mantiene)
    const isHighlighted = (item.title === hoveredItem); 
    const hoverProps = hasChildren ? {
        onMouseEnter: () => onHoverChange(item.title),
        onMouseLeave: () => onHoverChange(null),
    } : {};


    // FUNCIÓN CLAVE: Manejo de Clic y Notificación con Doble Argumento
    const handleItemClick = (e) => {
        
        // 1. Lógica de Colapso (Si tiene hijos)
        if (hasChildren) {
            e.preventDefault(); 
            setIsOpen(!isOpen);
        } 
        
        // 2. Lógica de Navegación/Selección (Elementos hoja)
        else {
            e.preventDefault();
            
            if (onComponentChange) {
              sessionStorage.setItem('currentModule', item.enlace !== '#' ? item.enlace : '');
                // Notifica a Admin.js: Envía el Nombre del Componente y la Ruta Activa
              onComponentChange(item.enlace, item.activo); 
            }
            
            // onSetActive ya no se llama localmente porque Admin.js lo maneja.
        }
    };

    // Determina las clases de estilo (se mantiene)
    let itemClass = '';
    if (isCurrentActive) {
        itemClass = 'is-active'; 
    } else if (isAncestorActive) {
        itemClass = 'is-ancestor';
    }


    return (
        <li 
            className={`menu-item ${item.activo} ${itemClass} ${isHighlighted ? 'highlighted' : ''}`}
            {...hoverProps} 
        >
            <a 
                href={item.enlace} 
                onClick={handleItemClick}
                className={`
                  menu-link 
                  text-white 
                  px-3 
                  d-flex 
                  justify-content-between 
                  align-items-center
                  ${item.enlace === sessionStorage.getItem("currentModule") ? 'active' : ''}
                `} 
            >
                {item.title}
                {hasChildren && <span className="arrow">{isOpen ? '▲' : '▼'}</span>} 
            </a>
            
            {/* Llamada Recursiva: Pasamos todos los props necesarios */}
            {hasChildren && (
                <ul className="submenu" style={{ display: isOpen ? 'block' : 'none' }}>
                    {item.hijos.map((child, index) => (
                        <MenuItem 
                            key={index} 
                            item={child} 
                            activePath={activePath} 
                            onSetActive={onSetActive} // Dummy
                            onHoverChange={onHoverChange}
                            hoveredItem={hoveredItem}
                            onComponentChange={onComponentChange} // <-- ¡Pasado recursivamente!
                        />
                    ))}
                </ul>
            )}
        </li>
    );
};

const MenuGestion = ({ activePath, onComponentChange }) => { 
    
    // Estados locales (solo Hover)
    const [hoveredItem, setHoveredItem] = useState(null);
    const menuItems = getGestionDeAlmacenMenu();
    const handleHoverChange = (title) => { setHoveredItem(title); };
    
    // Función dummy para onSetActive (ya no gestiona el estado, solo cumple la firma)
    const handleSetActiveDummy = () => {}; 
    
    return (
        <nav className="menu-importacion">
            <ul className="menu-list">
                {menuItems.map((item, index) => (
                    <MenuItem 
                        key={item.title || index} 
                        item={item} 
                        activePath={activePath} // <-- Recibido de Admin.js
                        onSetActive={handleSetActiveDummy} 
                        onHoverChange={handleHoverChange} 
                        hoveredItem={hoveredItem}
                        onComponentChange={onComponentChange} // <-- Función enviada al fondo
                    /> 
                ))}
            </ul>
        </nav>
    );
};



export default MenuGestion;
